<template>
  <div id="page">
    <nav>
      <router-link to="/toList"><div class="item">待做事项
        <p>这是一个Vue实现的待做事项，数据主要存储在localStorage</p>
        </div></router-link>
      <router-link to="/toMall"><div class="item">购物商城
        <p>这是一个Vue实现的商城系统，数据通过接口获取</p>
        </div></router-link>
    </nav>

    <div class="content">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: "myIndex",}
</script>

<style scoped>
nav {
  margin-top: 15rem;
}

.item {
    color: #000;
    font-weight: bold;
    box-shadow: inset 1px 1px 10px 0 #dcdcdc;
    height: 100%;
    padding-top: .2rem;


}
a:hover{
  transform: translateY(-.5rem);
  scale: 1.1;
}
.item p{
  font-size: 1.2rem;
  overflow-wrap: break-word;
text-align: left;
color: gray;
font-weight: initial
}

a {
  text-align: center;
font-size: 1.4rem;
width: 15rem;
background: white;
margin: 2rem auto;
height: 10rem;
display: block;
box-shadow: 0 0 10px 1px gray;
border-radius: 5px;
transition: scale 0.7s;
-webkit-transition:scale 0.7s ;
}
</style>